module.exports = __webpack_public_path__ + "e250c68b531f6067f8e03e48f60f5807.svg";